module.exports = require('./helpers/bundle-url').getBundleURL('iDchs') + "logo.c51670a8.svg";